module.exports = __webpack_public_path__ + "static/img/state5.f1cc0394.png";